var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.988 8.68 21 8.483c0-.81-.581-1.479-1.333-1.577l-.19-.012-14.213.001 4.081-4.27A1.65 1.65 0 0 0 9.446.701L9.32.53A1.477 1.477 0 0 0 7.33.272l-.163.133L.507 7.23A1.645 1.645 0 0 0 .36 9.444l6.806 7.146c.625.59 1.589.537 2.153-.116a1.648 1.648 0 0 0 .033-2.094l-4.01-4.308 14.134-.002c.777 0 1.418-.606 1.512-1.39Z",
  fill: "#FE5F00"
})));
export default SvgBack;